import { InjectionToken, Signal } from "@angular/core";
import { StorageKeys } from "../models/storage-keys";
import { DateFormatType } from "../models/date-format.model";
import { BaseSettingsGetService } from '../services/base-settings.service';
import { FilePreviewType, SettingsRoundnessLevel, SlideBackgroundData } from '../models';

export const STORAGE_KEYS = new InjectionToken<StorageKeys>('');
export const DATE_FORMATS = new InjectionToken<DateFormatType>('');
export const API_URL = new InjectionToken<string>('apiUrl');
export const API_CORE_APP_URL = new InjectionToken<string>('apiCoreAppUrl');
export const REGEX_LIST = new InjectionToken('REGEX_LIST');
export const SETTINGS_SERVICE = new InjectionToken<BaseSettingsGetService>('');
export const AUDIO_PLAYER_WAVE_SURFER_CONFIG = new InjectionToken<{ backend: string, preload: string, peaks: string[] }>('');
export const BUNDLE_TYPE_TEXT_MAP = new InjectionToken<any>('');
export const PLYR_DEFAULT_DRIVER = new InjectionToken<any>('');
export const PAGE_BLOCK_KEYS_MAP = new InjectionToken<any>('');
export const OVERRIDE_ICONS_FROM_SETTINGS = new InjectionToken<boolean>('');
export const DOCUMENT_PREVIEW_CONFIG = new InjectionToken<{ supportedTypes: FilePreviewType[] }>('');
export const ROUNDNESS_LEVEL_CLASSES_MAP = new InjectionToken<Record<SettingsRoundnessLevel, string>>('');
export const PHOSPHOR_ICON_LIST = new InjectionToken<{ icon: string, label: string }[]>('');
export const SLIDE_BUILDER_BACKGROUND_CONTEXT = new InjectionToken<Signal<Partial<SlideBackgroundData>>>('');
